"use client";

import { HydrationBoundary as TanstackHydrationBoundary, type HydrationBoundaryProps } from "@tanstack/react-query";

/**
 * Re-export HydrationBoundary with our custom defaults
 * This component is used to hydrate the query cache with server-prefetched data
 */
export function HydrationBoundary(props: HydrationBoundaryProps) {
  return <TanstackHydrationBoundary {...props} />;
}